export const data = [
  {
    id: 1,
    title: "Lebara KSA",
    description:
      "A Saudi telecommunications company, My role was to work as a full stack developer using React and Next.js for the front-end and Node.js for the back-end ..etc",
    image: "/assets/images/lebara.png",
    link: "https://lebara.sa/en",
  },
  {
    id: 2,
    title: "Toolmart",
    description:
      "The largest industrial store for industrial equipment in Iraq, My role was to work as a full stack developer using (Magento).",
    image: "/assets/images/toolmart.png",
    link: "https://toolmart.me/en",
  },
  {
    id: 3,
    title: "Sewara",
    description:
      "Digital tool for identifying children's information in schools and public places, utilizing NextJS for the UI, ASP API for the back-end, React Native for mobile app.",
    image: "/assets/images/sewara.png",
    link: "https://www.sewara-jo.com/",
  },
  {
    id: 4,
    title: "Al-fuhood Phones",
    description:
      "Alfuhod is a store specializing in selling and maintaining electronic devices and phones in particular, My role was to work in UI using React.",
    image: "/assets/images/alfuhood.png",
    link: "hhttps://alfuhoodqr.com/",
  },
  {
    id: 5,
    title: "Raniamanasra fashion",
    description:
      "A fashion website for selling bags, I worked on it using Magento.",
    image: "/assets/images/raniamanasra.png",
    link: "https://raniamanasra.com/en/",
  },
  {
    id: 6,
    title: "Luliz",
    description:
      "Luliz aiming to be the greatest online shopping cosmetics market from the area, My role was to work as a full stack developer using React and Node. ",
    image: "/assets/images/luliz.png",
    link: "https://luliz.com/en/",
  },
  {
    id: 7,
    title: "Sadad POS",
    description:
      "SADAD Logistics Services is providing electronic payment services licensed by the Central Bank of Jordan (POS), Using ASP for BE and React for FE",
    image: "/assets/images/sadad.png",
    link: "https://www.sadad.jo/",
  },
 
];
